import "./bike-park-header.scss"

require.context("./static", true, /\.jpg|svg$/)
